import axios from "axios";

interface IReturnCep {
  // viacep
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro: boolean;
  // apicep
  status: number;
  ok: boolean;
  code: string;
  state: string;
  city: string;
  district: string;
  address: string;
  statusText: string;
  message: string;
}

export async function getCEP(cep: string): Promise<IReturnCep> {
  try {
    const cepres: IReturnCep = (await axios.get(`https://viacep.com.br/ws/${cep}/json/`, {
      transformRequest: (data, headers) => {
        delete headers.common["OID_ACESSO"];
        return data;
      }
    })).data;

    if (cepres.erro === true) {
      throw ("");
    }

    return cepres;
  }
  catch {
    try {
      const cepres: IReturnCep = (await axios.get(`https://ws.apicep.com/cep/${cep}.json`, {
        transformRequest: (data, headers) => {
          delete headers.common["OID_ACESSO"];
          return data;
        }
      })).data;

      if (cepres.ok === false) {
        throw (cepres.message);
      }
    }
    catch (err) {
      throw (err["response"] ? err["response"]["data"] : err);
    }
  }
}